import React from 'react';
import T from 'i18n-react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

type props = {
  onChange: () => void;
  checked: boolean;
};

const OverTimeCheckbox = ({ onChange, checked }: props) => {
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox color="primary" onChange={onChange} checked={checked} />
        }
        label={T.translate(`planPage.planTerms.hasOvertimeWorkText`)}
      />
      <FormHelperText>
        {T.translate('planPage.planTerms.overTimeHelp')}
      </FormHelperText>
    </>
  );
};

export default OverTimeCheckbox;
